module.exports = __webpack_public_path__ + "static/media/PMIPMOCP.7716e2da.pdf";